import firebase from "../firebase.js";
import GENRALHELPERS from "../GENRAL-HELPERS.js";
import register from "../register/register.js";
import generateHtml from "./cta-generate-html.js";

class CTAAlert {
  async _closeCTARegister() {
    const ctaRegisterConMain = document.getElementById("ctaRegisterConMain");
    ctaRegisterConMain.style.display = "none";
  }
  async _openCTARegister(stats = false, header1Text, header2Text) {
    return // not needed for now
    function isHideRegisterAlertSet() {
      return document.cookie.split(";").some((cookie) => {
        return cookie.trim().startsWith("hideregisteralert=");
      });
    }

    if (isHideRegisterAlertSet()) return;

    const ctaRegisterConMain = document.getElementById("ctaRegisterConMain");

    const visits = GENRALHELPERS._formatToPrice(
      await firebase._getStats("stats/siteVisits/count")
    );
    const AppInstall = GENRALHELPERS._formatToPrice(
      await firebase._getStats("stats/PWAInstalls/count")
    );
    const listings = GENRALHELPERS._formatToPrice(
      await firebase._getStats("stats/listingsCreated/count")
    );
    const users = GENRALHELPERS._formatToPrice(
      await firebase._getStats("stats/accountsCreated/count")
    );
    const sellers = GENRALHELPERS._formatToPrice(
      await firebase._getStats("stats/sellerProfilesCreated/count")
    );
    const businesses = GENRALHELPERS._formatToPrice(
      await firebase._getStats("stats/businessesCreated/count")
    );
    let Btn1Disp = null;
    let Btn2Text = undefined;
    let DoNotShowDisp = null;

    if (stats) {
      Btn1Disp = "none";
      Btn2Text = "Cerrar";
      DoNotShowDisp = "none";
    }

    ctaRegisterConMain.innerHTML = generateHtml._CTARegister(
      visits,
      AppInstall,
      listings,
      users,
      sellers,
      businesses,
      header1Text,
      header2Text,
      Btn1Disp,
      Btn2Text,
      DoNotShowDisp
    );

    ctaRegisterConMain.style.display = "flex";
    this._eventCTARegister();
  }

  _eventCTARegister() {
    function handleCheckboxAndSetCookie() {
      const checkbox = document.getElementById(
        "ctaRegisterNotShowAnyMoreCheckBox"
      );

      if (checkbox.checked) {
        // Set cookie for 10 days
        const d = new Date();
        // d.setTime(d.getTime() + 30 * 1000); // 10 days in ms
        d.setTime(d.getTime() + 10 * 24 * 60 * 60 * 1000); // 10 days in ms
        const expires = "expires=" + d.toUTCString();
        document.cookie = "hideregisteralert=true;" + expires + ";path=/";
      }
    }

    const ctaRegisterButtonRegister = document.getElementById(
      "ctaRegisterButtonRegister"
    );
    const ctaRegisterButtonLater = document.getElementById(
      "ctaRegisterButtonLater"
    );

    ctaRegisterButtonRegister.addEventListener("click", () => {
      register._displayOptions(
        "account_and_profile",
        "Registrate si no tienes una cuenta",
        "register"
      );
      this._closeCTARegister();
    });
    ctaRegisterButtonLater.addEventListener("click", () => {
      handleCheckboxAndSetCookie();
      this._closeCTARegister();
    });
  }
}
export default new CTAAlert();
